import React, { useEffect, useMemo, useState } from "react";
const clientId = "7fKuPtQQaY578tlgj6ED7X8uyVlIAdzS";

const BuylineFinanceCalculator = ({ price, apr, term, theme }) => {
  const uniqueId = useMemo(
    () =>
      "buyline-finance-calculator-" + Math.random().toString(36).substr(2, 9),
    []
  );

  const [scriptLoaded, setScriptLoaded] = useState(false);

  // Load script once
  useEffect(() => {
    const scriptId = "buyline-widget-script";
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://vapor-eu-west-2-storage-production-63932.s3.eu-west-2.amazonaws.com/build/js/widget.js?v=1.0.0";
      script.async = true;
      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    } else if (window.buylineWidget) {
      setScriptLoaded(true);
    } else {
      // Script exists but not loaded yet
      const onLoad = () => setScriptLoaded(true);
      script.addEventListener("load", onLoad);
      return () => script.removeEventListener("load", onLoad);
    }
  }, []);

  // Initialize widget only once when script is loaded
  useEffect(() => {
    if (!scriptLoaded) return;
    if (!window.buylineWidget) return;

    // Prevent multiple initializations for the same div
    if (!document.getElementById(uniqueId).dataset.initialized) {
      window.buylineWidget(`#${uniqueId}`, {
        price,
        apr,
        term,
        theme,
        clientId,
      });
      document.getElementById(uniqueId).dataset.initialized = "true";
    }
  }, [scriptLoaded, uniqueId, price, apr, term, theme]);

  // Update price dynamically
  useEffect(() => {
    if (!scriptLoaded) return;
    const evt = new CustomEvent("buyline_update_widget", {
      bubbles: true,
      cancelable: false,
      detail: { amount: price },
    });
    document.dispatchEvent(evt);
  }, [price, scriptLoaded]);

  return <div id={uniqueId}></div>;
};

export default BuylineFinanceCalculator;
